import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { ButtonVariant } from "@/constants/button/button"
import { AppDispatch } from "@/redux"
import { useDispatch } from "react-redux"
import { workflowActions } from '@/redux/slice/workflowSlice'
import { OptionProps } from "@/types/workflow"
import { useEffect, useState } from "react"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"
import { FormMessage } from "@/components/ui/form"

export const JSONTextAreaOption: React.FC<OptionProps> = ({
  stepId,
  code,
  selectedValue,
  name,
  description,
  showOptionModal,
  optionModal,
  order
}: OptionProps) => {
  const dispatch: AppDispatch = useDispatch()
  const [jsonValue, setJsonValue] = useState('')
  const [hasFormError, setHasFormError] = useState(false)

  useEffect(() => {
    if (selectedValue) {
      setJsonValue(JSON.parse(selectedValue))
    } else {
      setJsonValue('')
    }
  }, [selectedValue])
  const checkIsValidJSON = (jsonString: string) => {
    try {
      const parsed = JSON.parse(jsonString)
      return typeof parsed === 'object' && parsed !== null
    } catch {
      return false
    }
  }

  return (
    <AlertDialog open={optionModal} onOpenChange={() => showOptionModal && showOptionModal(false)}>
      <AlertDialogTrigger>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="mb-6">
            <div className="flex flex-row items-start justify-between">
              <div className="flex flex-col items-start">
                <h4 className="text-primary font-semibold text-xl leading-5 mb-2">
                  Filter Setup: {name}
                </h4>
                <p className="text-secondary text-sm mb-2 text-left font-normal">{description}</p>
              </div>
              <div className="flex items-center">
                <AlertDialogCancel className="mx-4">Cancel</AlertDialogCancel>
                <Button variant={ButtonVariant.DEFAULT} type="button" onClick={async () => {
                  const isValid = checkIsValidJSON(jsonValue)
                  if (!isValid) return setHasFormError(true)
                  dispatch(workflowActions.setStepOption({
                    stepId,
                    order,
                    option: code,
                    optionValue: JSON.stringify(jsonValue, null, 2)
                  }))
                  setHasFormError(false)
                  showOptionModal && showOptionModal(false)
                }}>
                  Update Option
                </Button>
              </div>
            </div>
          </AlertDialogTitle>
          <div className="">
            <div className="my-4" />
            <Label>{name}</Label>
            <Textarea
              className={'bg-foreground text-primary w-[460px] bg-foreground max-h-[160px]'}
              value={jsonValue}
              onChange={e => setJsonValue(e.target.value)}
              hasError={hasFormError}
            />
            {hasFormError ? (
              <FormMessage
                showIcon={true}
                className="flex flex-row justify-start"
              >
                Must be a valid JSON object or array
              </FormMessage>
            ) : null}
          </div>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  )
}
